import { useEvent } from '@flippingbook/web.react-hooks/dist/useEvent';

const eventName =
    typeof (document as { webkitHidden?: boolean }).webkitHidden !== 'undefined'
        ? 'webkitvisibilitychange'
        : 'visibilitychange';

export function useVisibilityChange(handler: (event: Event) => void) {
    useEvent(eventName, handler);
}
